export default __webpack_public_path__ + "media/images/slider/slider-5-3719dfe8a63348a8b5244010a65040d5.png";